const useLocalizationSupport = (props, localizationOptions) => {
  const { translator, numberFormatter, dateFormatter } = localizationOptions;
  const translate = (key, params) => {
    if (props.locale && translator) {
      return translator.translate(key, props.locale, params);
    }
    return key;
  };
  const returnUnavailableOrNullMessage = (value) => {
    if (value === void 0) {
      return translate("localizationSupport.notDefined");
    }
    return translate("localizationSupport.notAvailable");
  };
  const isUnavailableOrNull = (value) => {
    return value === void 0 || value === null;
  };
  const numberFormat = (value, options) => {
    var _a, _b;
    if (isUnavailableOrNull(value) || isNaN(value)) {
      return returnUnavailableOrNullMessage(value);
    }
    if (props.locale && numberFormatter) {
      const formatterOptions = options != null ? options : {};
      formatterOptions.locale = props.locale;
      formatterOptions.assetClass = (_a = options == null ? void 0 : options.assetClass) != null ? _a : "default";
      formatterOptions.type = (_b = options == null ? void 0 : options.type) != null ? _b : "default";
      return numberFormatter.format(value, formatterOptions);
    }
    return String(value);
  };
  const dateFormat = (value, options) => {
    if (isUnavailableOrNull(value)) {
      return returnUnavailableOrNullMessage(value);
    }
    if (props.locale && dateFormatter) {
      const formatterOptions = options != null ? options : {};
      formatterOptions.locale = props.locale;
      if (options == null ? void 0 : options.format) {
        formatterOptions.format = options.format;
      }
      return dateFormatter.format(value, formatterOptions);
    }
    return String(value);
  };
  const relativeTimeFormat = (value, options) => {
    if (isUnavailableOrNull(value)) {
      return returnUnavailableOrNullMessage(value);
    }
    if (props.locale && dateFormatter) {
      const formatterOptions = options != null ? options : {};
      formatterOptions.locale = props.locale;
      if (options == null ? void 0 : options.format) {
        formatterOptions.format = options.format;
      }
      return dateFormatter.formatRelative(value, formatterOptions);
    }
    return String(value);
  };
  const textFormat = (value) => {
    if (isUnavailableOrNull(value)) {
      return returnUnavailableOrNullMessage(value);
    }
    return value;
  };
  const arrayFormat = (value) => {
    if (value === null || value === void 0 || value.length === 0) {
      return returnUnavailableOrNullMessage(value);
    }
    return value.join(", ");
  };
  return {
    numberFormat,
    textFormat,
    dateFormat,
    relativeTimeFormat,
    translate,
    arrayFormat
  };
};

export { useLocalizationSupport };
